import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useTempClientFormPageRedirect = () => {
  const {
    doRedirectOnPrevPage,
    doRedirectWithSavePageUrl: redirectOnClientForm,
    doSavePageUrl,
    prevPageUrl,
  } = usePagesRedirect('TempClientFormPage');
  return { doRedirectOnPrevPage, redirectOnClientForm, doSavePageUrl, prevPageUrl };
};
